import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, ENVIRONMENT_TOKEN } from '@core/models/environment.model';
import { AuthService } from '@core/services/auth/auth.service';
import { from, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    @Inject(ENVIRONMENT_TOKEN) private env: Environment,
    private authService: AuthService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url || req.url.includes('/assets/')) {
      return next.handle(req);
    }
    return this.refreshTokenIfExpired().pipe(switchMap(() => next.handle(this.addHeader(req))));
  }

  private refreshTokenIfExpired(): Observable<void> {
    const expired = this.authService.isKeycloakTokenExpired();
    if (expired) {
      return from(this.authService.refreshToken());
    } else {
      return of(null);
    }
  }

  private addHeader(request: HttpRequest<any>): HttpRequest<any> {
    const token = this.authService.fdGwToken;
    return request.clone({
      setHeaders: {
        authorization: `Bearer ${token}`,
        'x-client': this.env.xClientName
      }
    });
  }
}
